"use strict";

angular.module('app.controllers.softwareUpdate', []).config(['$stateProvider', function($stateProvider) {
    $stateProvider.state('softwareUpdate', {
        parent: 'site',
        url: '/softwareUpdate',
        templateUrl: 'views/CustomActions/softwareUpdate.html',
        controller: 'softwareUpdateCtrl'
    });
}]).controller("softwareUpdateCtrl", ['$scope', '$timeout', '$state', '__DatapointValue', '__DatapointConfig', 'f_Interval', 'conf_guidEmpty', 'appConfig', '$http', '$rootScope', 'API', 'f_User', 'frontEndSettingsService', 'ENUM', '$filter', 'xCenterConfig',
    function($scope, $timeout, $state, __DatapointValue, __DatapointConfig, f_Interval, conf_guidEmpty, appConfig, $http, $rootScope, API, f_User, frontEndSettingsService, ENUM, $filter, xCenterConfig) {
        $scope.init = function() {
            $scope.StatusText = '';
            frontEndSettingsService.getFrontendSettings()
                .then(function(settings) {
                    $scope.orgId = settings.OrgId;
                });
            f_Interval.pauseAllRunningInvervals();
            $scope.Percent = 0;
            var o = [{
                'DatapointConfigId': '61afe142-5709-47f3-9624-511f6c96ec00',
                'DeviceId': conf_guidEmpty
            }];
            // Datapoint to write. On Device 00000 "0c4e9f8a-d0b7-4474-86f8-77a1adb0889d"
            var startUpdate = {
                '$type': "BMS.Shared.DatapointCore.DatapointValue`1[[System.Boolean, mscorlib]], BMS.Shared",
                'DatapointConfigId': xCenterConfig.systemDatapoints.InitiateUpdate,
                'DeviceId': conf_guidEmpty,
                'Value': true,
            };
            __DatapointConfig
                .$ByDeviceId({
                    DeviceId: conf_guidEmpty,
                    DatapointConfigIds: ['61afe142-5709-47f3-9624-511f6c96ec00']
                })
                .$then(function(data) {
                    $scope.config = data[0];
                    $scope.status = __DatapointValue.$collection(o).$refresh().$then(function(data) {
                        // If new Version is available for installation
                        if (data[0].Value) {
                            // Set update to true!!!
                            $scope.handleNewStatus(1);

                            __DatapointValue.$buildRaw(startUpdate).$save().$then(function() {
                                // Now init intervall for listeing Software Update Status
                                $scope.i = {
                                    'AppId': 'interval.softwareUpdate.Status',
                                    delay: 2000,
                                    fn: function() {
                                        __DatapointValue
                                        .$collection(o)
                                        .$refresh()
                                        .$then(function(data) {
                                            $scope.handleNewStatus(data[0].Value);
                                        }, function(data) {
                                            // Server is Restarting
                                            $scope.waitForConnection();
                                        });
                                    }
                                };

                                $scope.intervalId = f_Interval.registerInterval($scope.i);
                            });

                        } else {
                            // if different Status. Redirect.
                            // Mostly Version up do date => $state.go('main');
                            $scope.handleNewStatus(data[0].Value);
                        }


                    });
                });
        };




        $scope.handleNewStatus = function(status) {
            $scope.StatusText = status + '--' + $scope.config.PossibleValues[status];
            switch (status) {
                case 0:
                    $scope.StatusTitle = $scope.config.PossibleValues[status];
                    $scope.StatusText = 'SYSTEM_SoftwareUpdate_VersionUpToDate';
                    $scope.Percent = -1;
                    if ($scope.DownloadTimeout) {
                        $timeout.cancel($scope.DownloadTimeout);
                    }
                    $timeout(function() {
                        $state.go('main');
                    }, 4000);
                    break;
                case 1:
                    $scope.StatusTitle = $scope.config.PossibleValues[status];
                    $scope.StatusText = 'SYSTEM_SoftwareUpdate_Downloading';
                    $scope.Percent = -1;
                    if ($scope.DownloadTimeout) {
                        $timeout.cancel($scope.DownloadTimeout);
                    }
                    break;
                case 2:
                    $scope.StatusTitle = $scope.config.PossibleValues[status];
                    $scope.StatusText = 'SYSTEM_SoftwareUpdate_Downloading';
                    // If timeout exists,
                    $scope.CheckDownloadProgress = function() {
                        var o = [{
                            'DatapointConfigId': '11280ea1-c02d-434e-9ed0-b17be8a5e4b6',
                            'DeviceId': conf_guidEmpty
                        }];
                        __DatapointValue
                        .$collection(o)
                        .$refresh()
                        .$then(function(data) {
                            $scope.Percent = data[0].Value;
                        }, function(data) {
                            // Server is Restarting
                            $scope.waitForConnection();
                        });

                        $scope.DownloadTimeout = $timeout(function() {
                            // fetch donwload progress
                            $scope.CheckDownloadProgress();
                        }, 2000);
                    };
                    if (!$scope.DownloadTimeout) {
                        $scope.CheckDownloadProgress();
                    }

                    break;
                case 3:
                    $scope.StatusTitle = $scope.config.PossibleValues[status];
                    $scope.StatusText = 'SYSTEM_SoftwareUpdate_DownloadFinished';
                    $scope.Percent = 100;
                    if ($scope.DownloadTimeout) {
                        $timeout.cancel($scope.DownloadTimeout);
                    }

                    break;
                case 4:
                    $scope.StatusTitle = $scope.config.PossibleValues[status];
                    $scope.StatusText = 'SYSTEM_SoftwareUpdate_NoConnection';
                    $scope.Percent = -1;
                    if ($scope.DownloadTimeout) {
                        $timeout.cancel($scope.DownloadTimeout);
                    }
                    $timeout(function() {
                        $state.go('main');
                    }, 4000);
                    break;
                case 5:
                    $scope.StatusTitle = $scope.config.PossibleValues[status];
                    $scope.StatusText = 'SYSTEM_SoftwareUpdate_UpdateError';
                    $scope.Percent = -1;
                    if ($scope.DownloadTimeout) {
                        $timeout.cancel($scope.DownloadTimeout);
                    }
                    $timeout(function() {
                        $state.go('main');
                    }, 4000);
                    break;
                case 6:
                    // Version not found
                    $scope.StatusTitle = $scope.config.PossibleValues[status];
                    $scope.StatusText = 'SYSTEM_SoftwareUpdate_VersionNotFound';
                    $scope.Percent = -1;
                    if ($scope.DownloadTimeout) {
                        $timeout.cancel($scope.DownloadTimeout);
                    }
                    $timeout(function() {
                        $state.go('main');
                    }, 4000);
                    break;
                case 7:
                    $scope.StatusTitle = $scope.config.PossibleValues[status];
                    $scope.StatusText = 'SYSTEM_SoftwareUpdate_Unpacking';
                    $scope.Percent = -1;
                    if ($scope.DownloadTimeout) {
                        $timeout.cancel($scope.DownloadTimeout);
                    }
                    break;
                case 8:
                    $scope.StatusTitle = $scope.config.PossibleValues[status];
                    $scope.StatusText = 'SYSTEM_SoftwareUpdate_OSUpdate';
                    $scope.Percent = -1;
                    if ($scope.DownloadTimeout) {
                        $timeout.cancel($scope.DownloadTimeout);
                    }
                    break;
            }
        };


        $scope.waitForConnection = function() {
            // DatapointValue (Percent) Timeout called before Value of UpdateStatus
            if ($scope.startedWaiting == true) {
                return;
            }
            $scope.startedWaiting = true;
            f_Interval.unregisterAllIntervals();
            f_Interval.unregisterIntervalByAppId('interval.softwareUpdate.Status');
            f_Interval.unregisterIntervalByAppId($scope.i);
            if ($scope.DownloadTimeout) {
                $timeout.cancel($scope.DownloadTimeout);
            }
            $scope.StatusText = 'SYSTEM_SoftwareUpdate_OSUpdate';
            $timeout(function() {
                ENUM.getEnum('ExceptionType')
                    .$then(function(resp) {
                        $scope.timeoutEx = ($filter('filter')(resp, {
                            EnumValueKey: 'Timeout'
                        }, true))[0];
                    });

                $scope.isServerAwake();
            }, 5000);
        };

        $scope.isServerAwake = function() {
            $rootScope.blockAllInteraction = 'SoftwareUpdate';
            $rootScope.surpressErrors = true;

            $http({
                method: 'POST',
                url: appConfig().api_host + 'Favorite/GetFavorites/' + appConfig().destinationId,
                data: '',
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8'
                }})
                .then(function(response) {
                    if (response
                        && response.data
                        && response.data.ExceptionData
                        && response.data.ExceptionData.ExeptionType === $scope.timeoutEx.EnumValueKeyNumber) {
                        $timeout(function() {
                            $scope.isServerAwake();
                        }, 5000);
                        return;
                    }

                    $scope.StatusText = 'SYSTEM_SoftwareUpdate_Finished';

                    $timeout(function() {
                        startActionAfterRestart();
                    }, 2000);
                }, function(resp) {
                    // Server is not awake. Restarting
                    if (resp && (resp.status === 401 || resp.status === 200)) {
                        $scope.StatusText = 'SYSTEM_SoftwareUpdate_Finished';
                        $timeout(function() {
                            $rootScope.blockAllInteraction = false;
                            startActionAfterRestart();
                        }, 5000);
                    } else {
                        $scope.StatusText = 'SYSTEM_RestartBody';
                        $timeout(function() {
                            $scope.isServerAwake();
                        }, 5000);
                    }

                });
        };

        function startActionAfterRestart() {
            const isRemoteConfigActive = (remoteConfig !== undefined ? true : false);

            if (isRemoteConfigActive) {
                $state.reload();
            } else {
                doLogout();
            }
        }

        function doLogout() {
            var api = new API();
            api.Security.Logout();
            f_User.setUserLevel(0);
            $timeout(function() {
                $state.go('login', {
                    notLoggedIn: true
                }, {
                    'reload': true
                });
            }, 5000);
        }

        $scope.init();

    }
]);
